import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BreederInfo } from '../classes/breeder';
import { APIService } from './api.service';
import { ClaimRewardPostModel } from '../classes/claim-reward-post-model';
import { SaveInformationPostModel } from '../classes/save-information-post-model';
import { SaveInformationResponseModel } from '../classes/save-information-response-model';

@Injectable()
export class BreederService extends APIService{
  constructor(private _http: HttpClient) { super(); }

  public getBreederInfo(): Observable<BreederInfo> {
    return this._http.get<BreederInfo>(`${this._baseUrl}/v1/breeder/me`);
  }

  public saveRegisterInformation(body: SaveInformationPostModel): Observable<any> {    
   return this._http.post<SaveInformationResponseModel>(`${this._baseUrl}/v1/breeder/`, body);
  }

  public getMyDogs(yearFilter?: any): Observable<any> {
    if (yearFilter && yearFilter.toString() !== 'null') {
      return this._http.get(`${this._baseUrl}/v1/breeder/me/dogs?year=${yearFilter}`);
    } else {
      return this._http.get(`${this._baseUrl}/v1/breeder/me/dogs`);
    }
  }

  public claimReward(body: ClaimRewardPostModel): Observable<any> {
    return this._http.post(`${this._baseUrl}/v1/breeder/me/claimreward`, body);
  }

  public getLevelAccordingToPoints(points: number): string {
    if (points > 0 && points < 100) {
      return 'Beginner';
    } else if (points >= 100 &&points < 250) {
      return 'Brons';
    } else if (points >= 250 && points < 500) {
      return 'Zilver';
    }else {
      return 'Goud';
    }
  }
}
